import React from "react";
import { colors2, icons, UI_BODY_SEMIBOLD_SM, UI_BODY_SEMIBOLD_SM_DF } from "oolib";
import styled from "styled-components";

const StyledSection = styled.div`
  border-bottom: 1px solid ${colors2.grey10};
  margin: 0 -1.6rem;
  padding: 0 1.6rem 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0.4rem 0;
`;

const StyledChildren = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  /* When the passed child renders nothing (e.g. a section body that early
     returns null), this wrapper is genuinely empty — collapse it so it adds
     no gap/space under the header. */
  &:empty {
    display: none;
  }
`;

export const ConfigForm_SectionWrapper = ({ icon, title, headerRight, children }) => {
  const IconComp = icon && icons[icon] ? icons[icon] : null;

  return (
    <StyledSection>
      <StyledHeader>
        <StyledHeaderLeft>
          {IconComp && <IconComp size={16} color={colors2.grey80} weight="bold" />}
          <UI_BODY_SEMIBOLD_SM style={{ color: colors2.grey80 }}>
            {title}
          </UI_BODY_SEMIBOLD_SM>
        </StyledHeaderLeft>
        <div style={{ marginRight: "-4px" }}>
          {headerRight}
        </div>
      </StyledHeader>
      {children && <StyledChildren>{children}</StyledChildren>}
    </StyledSection>
  );
};
